<template>
    <b-card no-body>

        <b-modal id="assign-plate" title="Plaka Atama" no-close-on-esc no-close-on-backdrop>
            <inventory-assign-plate v-model="plate" :plates="plates" :errors="errors"></inventory-assign-plate>
            <template #modal-footer><v-executer :loading="loading" text="Ata" :action="changePlate"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :items-provider="provider"
                    :add-callback="createNew"
                    name="inventory"
                    :fields="fields"
                    :buttons="buttons"
                    pagination="server"
                    search>
        </v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import VehicleOperationsApi from '@/api/vehicle-operations'
import InventoryAssignPlate from './components/InventoryAssignPlate.vue'

export default {
    components:{
        BCard,
        InventoryAssignPlate
    },
    data(){
        return{
            editing:false,
            loading:false,
            errors:{},
            plates:[],
            fields:[
                { name:"Envanter No",key:"InventoryNo", thClass:"w-10",sortable:true,tdClass:'text-nowrap'},
                { name:"Çalışma Grubu",key:"WorkingGroupName", thClass:"w-10",sortable:true,sortKey:"WorkingGroup.Name"},
                { name:"Firma",key:"FirmName", tdClass:'text-nowrap',thClass:"w-10",sortable:true,sortKey:"Firm.Name"},
                { name:"Plaka No",key:"PlateValue", thClass:"w-10",sortable:true,sortKey:"Plate.PlateValue"},
                { name:"Marka",key:"VehicleBrandName", thClass:"w-10",sortable:true,sortKey:"Vehicle.VehicleBrand.Name",tdClass:'text-nowrap'},
                { name:"Model",key:"VehicleBrandModelName", thClass:"w-10",sortable:true,sortKey:"Vehicle.VehicleBrandModel.Name",tdClass:'text-nowrap'},
                { name:"Model Seri No",key:"VehicleBrandModelSerialName", thClass:"w-10",sortable:true,sortKey:"Vehicle.VehicleBrandModelSerial.Name",tdClass:'text-nowrap'},
                { name:"Model Yılı", key: "VehicleModelYear", thClass:"w-10", sortable:true, sortKey:'Vehicle.VehicleModelYear'},
                { name:"Araç Tipi",key:"VehicleTypeName",tdClass:'text-nowrap', thClass:"w-10",sortable:true,sortKey:"Vehicle.VehicleType.Name"},
                { name:"Araç Ana Tipi",key:"VehicleTypeBaseTypeName", thClass:"w-10",sortable:true,sortKey:"Vehicle.VehicleType.VehicleTypeBaseType.Name"},
            ],
            buttons:[
                { text:"Plaka Atama",key:"plate",icon:"GitPullRequestIcon",variant:"primary",action:this.assignPlate },
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
            ],
            plate:{
                VehicleInventoryId:null,
                OldVehiclePlateId:null,
                VehiclePlateId:null,
                PlateRemoveReason:null,
            }
        }
    },
    methods:{
        clearForm(){
            this.plate.VehicleInventoryId = null
            this.plate.VehiclePlateId = null
            this.plate.OldVehiclePlateId = null
            this.plate.PlateRemoveReason = null
        },
        createNew(){
            this.$router.push({name:'inventory-create-or-update',params:{id:0}})
        },
        edit(item){
            this.$router.push({name:'inventory-create-or-update',params:{id:item.Id}})
        },
        provider(data){
            return VehicleOperationsApi.Inventory.Table(data)
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.InventoryNo} envanter numarasına ait araç envanterini silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    VehicleOperationsApi.Inventory.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        },
        getPlates(plate){
            return new Promise((resolve,reject)=>{
                VehicleOperationsApi.Plate.ListViaNotUsingWithUsingPlate(plate || null)
                .then(response => {
                    this.plates = response.data.Data
                    resolve()
                }).catch(err=>{ reject() })
            })
        },
        assignPlate(item){
            this.clearForm()
            this.plate.VehicleInventoryId = item.Id
            this.plate.VehiclePlateId = item.PlateId
            this.plate.OldVehiclePlateId = item.PlateId
            this.$refs.table.rowLoading(true)
            this.getPlates(item.PlateId).then(()=>{
                this.$showModal("assign-plate")
                this.$refs.table.rowLoading(false)
            }).catch(()=>{
                this.$refs.table.rowLoading(false)
            })
            this.$root.$emit('bv::hide::tooltip')
        },
        changePlate(){
            let data = {
                VehicleInventoryId:this.plate.VehicleInventoryId,
                VehiclePlateId:this.plate.VehiclePlateId,
                PlateRemoveReason:this.plate.PlateRemoveReason,
            }
            this.loading = true
            VehicleOperationsApi.Inventory.ChangePlate(data).then(res=>{
                if(res.data.Success) {
                    this.$refs.table.refresh()
                    this.$hideModal("assign-plate")
                }
                this.loading = false
                this.$result(res)
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        }
    }
}
</script>

<style>

</style>